export const ROLE_CLIENT = 1;
export const ROLE_PROJECT_DESIGNER = 2;
export const ROLE_EMPLOYEE = 2;
export const ROLE_PROJECT_MANAGER = 3;
export const ROLE_ADMIN = 4;
export const ROLE_SUPER_ADMIN = 5;
